import { useEffect, useState } from 'react';
import useApi from './useApi';
import { USCGGroup } from '../types/ProductTypes';
import { useAppSettings } from '../hooks/useAppSettings';

export const useGetUSCGGroups = () => {
    const { state, getApiData } = useApi();
    const { settings: appSettings } = useAppSettings();
    const [uscgGroups, setUscgGroups] = useState<USCGGroup[] | null>(null);

    useEffect(() => {
        const fetchUSCGGroups = async () => {
            try {
                const apiUrl = appSettings?.api;
                if (!apiUrl) {
                    console.warn('[useGetUSCGGroups] API URL not configured in app settings');
                    return;
                }
                await getApiData({ endpoint: `${apiUrl}/GetUscgGroups` });
            } catch (error) {
                console.error('[useGetUSCGGroups] Failed to fetch USCG groups:', error);
            }
        };

        if (appSettings?.api) {
            fetchUSCGGroups();
        }
    }, [appSettings?.api, getApiData]);

    useEffect(() => {
        if (state.status === 'success' && state.result) {
            // Handle different response formats
            let groups: USCGGroup[] = [];
            if (Array.isArray(state.result)) {
                groups = state.result;
            } else if (state.result.data && Array.isArray(state.result.data)) {
                groups = state.result.data;
            } else if (typeof state.result === 'object') {
                console.warn('[useGetUSCGGroups] Unexpected response format:', state.result);
            }
            setUscgGroups(groups);
        }
    }, [state.status, state.result]);

    return {
        uscgGroups,
        isLoading: state.isLoading,
        error: state.error,
    };
};
